import { siteInfo } from '@/mocks/home';

export default function HeroSection() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/60 via-transparent to-background-50"></div>

      <div className="relative w-full px-4 md:px-6 max-w-7xl mx-auto pt-24 pb-16 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* left text */}
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>{siteInfo.tagline}</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-foreground-950 mb-4">
              {siteInfo.name}
              <span className="block text-primary-600 text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-2">
                {siteInfo.slogan}
              </span>
            </h1>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              {siteInfo.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {siteInfo.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-lg md:text-xl font-bold text-primary-600 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleNavClick('#ranking'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热门榜单
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleNavClick('#index'); }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                浏览分类索引
              </a>
            </div>
          </div>

          {/* right visual */}
          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=grand%20cinema%20theater%20interior%20with%20red%20velvet%20curtains%20and%20golden%20decorations%20warm%20dramatic%20lighting%20empty%20stage%20with%20spotlight%20elegant%20atmosphere%20classic%20movie%20palace%20style%20rich%20crimson%20and%20gold%20tones%20artistic%20composition&width=800&height=1000&seq=hero-main&orientation=portrait"
                alt="妖精影院 - 免费在线观看平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-background-50 text-sm font-medium">即点即播</div>
                    <div className="text-background-50/70 text-xs">无需等待，流畅观影</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-100 to-transparent pointer-events-none"></div>
    </section>
  );
}